import Errors from './Errors';
import swal from 'sweetalert';
import { event }  from '~/events'

class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data) {
        this.originalData = data;
        this.busy = false;
        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }

    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            // skip loop if the property is from prototype
            if (!this.originalData.hasOwnProperty(property)) continue;

            data[property] = this[property];
        }

        return data;
    }

    fill(data) {
        for (let property in data) {
            // skip loop if the property is from prototype
            if (!data.hasOwnProperty(property)) continue;

            this.setId(data.id);
            if (property in this) {
                this[property] = data[property];
            }
        }
    }

    setId(id) {
        this.id = id;
        this.originalData['id'] = id;
    }

    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            // skip loop if the property is from prototype
            if (!this.originalData.hasOwnProperty(field)) continue;

            this[field] = this.originalData[field];
        }

        this.errors.clear();
    }

    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url) {
        return this.submit('post', url);
    }

    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('put', url);
    }

    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit('patch', url);
    }

    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit('delete', url);
    }

    /**
     * Adds data to FormData object
     *
     * @param FormData
     * @param data
     * @param name
     */
    appendFormdata(FormData, data, name){
        name = name || '';

        if (data === null || typeof data === 'undefined') {
            // Do nothing
            return;
        } else if (typeof data === 'boolean') {
            FormData.append(name, data ? '1' : '0');
        } else if (data instanceof Date) {
            FormData.append(name, moment(data).toISOString(true));
        } else if (data instanceof File) {
            FormData.append(name, data);
        } else if (typeof data === 'object') {
            for (let d of Object.entries(data)) {if (name === '') {
                    this.appendFormdata(FormData, d[1], d[0]);
                } else {
                    this.appendFormdata(FormData, d[1], name + '[' + d[0] + ']');
                }
            }
        } else if (data instanceof Array) {
            for (let [index, value] in data) {
                this.appendFormdata(FormData, value, name + '[' + index + ']');
            }
        } else {
            FormData.append(name, data);
        }
    }

    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     * @return void|Promise<any>
     */
    submit(requestType, url) {
        if (this.busy)
            return;

        this.busy = true;

        let formData = new FormData;
        this.appendFormdata(formData, this.data());

        return new Promise((resolve, reject) => {
            window.axios[requestType](url, formData)
            .then(response => {
                this.busy = false;
                resolve(response.data);
            })
            .catch(error => {
                this.busy = false;
                if (error.response.status === 400) {
                    return this.displayErrors(error.response.data)
                }
                this.onFail(error.response.data.errors);
                event.init();
                event.emit('scrollToInput');
                reject(error.response.data);
            });
        });
    }

    displayErrors(response) {
        swal("Oops", response.message, "error");
    }

    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        this.errors.record(errors);
    }
}

export default Form